export default __webpack_public_path__ + "static/static-asset-simBubble-1941e067935c4ed29b8a26d7a42104e4.svg";